import { useSDUIActionsHandler } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/ActionHandler/useSDUIActionsHandler";
import { logSDUIEvent } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/EventLogging/logSDUIEvent";
import { QualtricsRetailerEvent, triggerQualtricsEvent } from "@faire/web--source/common/in-product-survey/qualtrics";
import { trackCategoriesLayoutElementCtaClick } from "@faire/web-api--source/events/categories/click/layoutElementCta";
import { trackCategoriesLayoutElementItemClick } from "@faire/web-api--source/events/categories/click/layoutElementItem";
import { trackHomeFeedLayoutElementCtaClick } from "@faire/web-api--source/events/homeFeed/click/layoutElementCta";
import { trackHomeFeedLayoutElementItemClick } from "@faire/web-api--source/events/homeFeed/click/layoutElementItem";
import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";
import { useCallback } from "react";
export function useSDUIOnClickHandler(actions, loggingData) {
    var eventOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        logSDUIClickEvent: true,
        logLegacyClickEvent: false
    };
    var actionsHandler = useSDUIActionsHandler(actions, loggingData);
    return useCallback(function() {
        actionsHandler();
        if (eventOptions.logSDUIClickEvent) {
            logSDUIEvent("CLICK", loggingData);
        }
        if (eventOptions.logLegacyClickEvent && "component_name" in loggingData && loggingData.component_name) {
            fireLegacyLayoutClickEvent(loggingData);
        }
    }, [
        actionsHandler,
        loggingData,
        eventOptions
    ]);
}
var fireLegacyLayoutClickEvent = function(loggingData) {
    if (loggingData.view_display_page === DisplayPageType.HOMEPAGE) {
        if ("action_instance_identifier" in loggingData && loggingData.action_instance_identifier) {
            var _loggingData_component_name, _loggingData_request_id;
            trackHomeFeedLayoutElementItemClick((_loggingData_component_name = loggingData.component_name) !== null && _loggingData_component_name !== void 0 ? _loggingData_component_name : "", (_loggingData_request_id = loggingData.request_id) !== null && _loggingData_request_id !== void 0 ? _loggingData_request_id : "", loggingData.action_instance_identifier);
        } else {
            var _loggingData_component_name1, _loggingData_request_id1;
            trackHomeFeedLayoutElementCtaClick((_loggingData_component_name1 = loggingData.component_name) !== null && _loggingData_component_name1 !== void 0 ? _loggingData_component_name1 : "", (_loggingData_request_id1 = loggingData.request_id) !== null && _loggingData_request_id1 !== void 0 ? _loggingData_request_id1 : "");
        }
    }
    if (loggingData.view_display_page === DisplayPageType.CATEGORY_PAGE) {
        if ("action_instance_identifier" in loggingData && loggingData.action_instance_identifier) {
            var _loggingData_component_name2, _loggingData_request_id2;
            trackCategoriesLayoutElementItemClick((_loggingData_component_name2 = loggingData.component_name) !== null && _loggingData_component_name2 !== void 0 ? _loggingData_component_name2 : "", (_loggingData_request_id2 = loggingData.request_id) !== null && _loggingData_request_id2 !== void 0 ? _loggingData_request_id2 : "", loggingData.action_instance_identifier);
        } else {
            var _loggingData_component_name3, _loggingData_request_id3;
            trackCategoriesLayoutElementCtaClick((_loggingData_component_name3 = loggingData.component_name) !== null && _loggingData_component_name3 !== void 0 ? _loggingData_component_name3 : "", (_loggingData_request_id3 = loggingData.request_id) !== null && _loggingData_request_id3 !== void 0 ? _loggingData_request_id3 : "");
        }
    }
    // TODO: https://fairewholesale.atlassian.net/browse/FD-251821
    // clean up after Discovery sub-jobs measurement survey is complete
    if (loggingData.view_display_page === DisplayPageType.HOMEPAGE && (loggingData.component_type === "PRODUCT_TILE_CAROUSEL" || loggingData.component_type === "SMALL_MAKER_TILE_CAROUSEL")) {
        triggerQualtricsEvent(QualtricsRetailerEvent.clickOnHomepageCarousel);
    }
};
